<template>
  <div class="container-fluid bg-custom min-vh-100 py-5">
    <div class="card custom-card shadow-lg p-4 w-100">
      <h2 class="text-center text-light fw-bold mb-1">CSV Upload, Preview & Download</h2>
      <p class="text-light">Showing {{ filteredData.length }} rows</p>

      <div class="mb-1">
        <label class="form-label text-light">Upload CSV File</label>
        <div class="input-group">

       <input
       type="file"
       ref="fileInput"
     @click="resetFileInput"
      @change="handleFileUpload"
      accept=".csv"
     class="form-control"
      />

          <button class="btn btn-primary" @click="uploadCsv" :disabled="!file || isLoading || isParsing || uploadAttempted">
            <i class="fas fa-upload"></i> Upload
          </button>
        

        </div>
        <p v-if="errorMessage" class="error-message mt-3">
          <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
        </p>
      </div>
      <div
        v-if="isLoading || isParsing"
        class="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
        style="background-color: rgba(0, 0, 0, 0.6); z-index: 1050"
      >
        <div class="text-center text-white">
          <div
            class="spinner-border text-light"
            role="status"
            style="width: 4rem; height: 4rem"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-4 mb-0 fw-bold" style="font-size: 1.5rem">
            Processing CSV file, please wait...
          </p>
        </div>
      </div>
    <!--   <div class="text-center mt-2" v-if="csvData.length > 0 && downloadUrl">
        <a :href="downloadUrl" class="btn btn-success" download>
          <i class="fas fa-download"></i> Download Result CSV
        </a>
      </div> -->
      <div class="text-center mt-2" v-if="csvData.length > 0 && downloadUrl">
  <button class="btn btn-success" @click="downloadCsv" :disabled="isLoading">
    <i class="fas fa-download"></i>
    <span v-if="!isLoading"> Download Result CSV</span>
    <span v-else> Downloading...</span>
  </button>
</div>

      <div v-if="csvData.length > 0 && downloadUrl" class="">
        <div class="d-flex justify-content-end">
          <label style="margin-right: 35px; font-weight: bold">
            Select rows for 1 page
          </label>
        </div>
        <div class="d-flex justify-content-end mb-2">
          <select class="form-select w-auto" v-model.number="itemsPerPage">
            <option disabled>Select Rows Per Page</option>
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
      </div>
      <div v-if="csvData.length" class="table-section">
        <div class="input-group mb-2 search-wrapper">
          <span class="input-group-text bg-gradient text-white">
            <i class="fas fa-search" style="color: black"></i>
          </span>
          <input
            type="text"
            v-model="searchTerm"
            class="form-control"
            placeholder="Search"
          />
        </div>

        <h5 v-if="filteredData.length === 0" style="color: red; text-align: center">
          No Data Found
        </h5>

     <!--    <div
          class="scroll-wrapper scroll-top"
          ref="topScroller"
          @scroll="syncScroll('top')"
        >
          <div class="scroll-inner" :style="{ width: tableScrollWidth + 'px' }"></div>
        </div> -->
        <div
          class="table-responsive scroll-wrapper scroll-bottom"
          ref="tableScrollContainer"
         
        >
  <!--       @scroll="syncScroll('bottom')" -->
          <table class="table table-bordered table-hover text-center custom-table">
            <thead>
              <tr>
                <th v-for="(header, i) in csvHeaders" :key="i">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in paginatedData" :key="i">
                <td v-for="(header, j) in csvHeaders" :key="j">{{ row[header] }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <nav v-if="totalPages > 1" class="mt-3 d-flex justify-content-center">
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <button class="page-link" @click="goToPage(currentPage - 1)">−</button>
            </li>

            <li class="page-item" :class="{ active: currentPage === 1 }">
              <button class="page-link" @click="goToPage(1)">1</button>
            </li>

            <li
              v-if="currentPage !== 1 && currentPage !== totalPages"
              class="page-item active"
            >
              <span class="page-link">{{ currentPage }}</span>
            </li>

            <li class="page-item" :class="{ active: currentPage === totalPages }">
              <button class="page-link" @click="goToPage(totalPages)">
                {{ totalPages }}
              </button>
            </li>

            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
              <button class="page-link" @click="goToPage(currentPage + 1)">+</button>
            </li>

            <li class="page-item ms-2">
              <input
                type="number"
                class="form-control"
                placeholder="Go to page"
                min="1"
                :max="totalPages"
                v-model.number="jumpPage"
                @keyup.enter="goToPage(jumpPage)"
                :disabled="totalPages === 0"
                style="width: 120px; height: 40px"
              />
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="modal fade" ref="csvModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Upload Successful</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body text-success">
            Successfully Calculated Tax. Now you can Download and Preview the File.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="closeModal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Papa from "papaparse";
import { UploadCSVfile } from "../End Points/api";
import * as bootstrap from "bootstrap";

export default {
  data() {
    return {
      file: null,
      errorMessage: "",
      downloadUrl: "",
      csvData: [],
      csvHeaders: [],
      searchTerm: "",
      modalInstance: null,
      isLoading: false,
      isParsing: false,
      currentPage: 1,
      itemsPerPage: 10,
      tableScrollWidth: 0,
      jumpPage: null,
      uploadAttempted: false,
    };
  },
  computed: {
    filteredData() {
      if (!this.searchTerm) return this.csvData;
      return this.csvData.filter((row) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(this.searchTerm.toLowerCase())
        )
      );
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.itemsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredData.slice(start, start + this.itemsPerPage);
    },
    visiblePages() {
      const range = 2;
      let pages = [];

      for (
        let i = Math.max(2, this.currentPage - range);
        i <= Math.min(this.totalPages - 1, this.currentPage + range);
        i++
      ) {
        pages.push(i);
      }

      return pages;
    },
  },
  watch: {
    itemsPerPage() {
      this.currentPage = 1;
    },
    searchTerm() {
      this.currentPage = 1;
    },
    filteredData() {
      this.updateScrollWidth();
    },
  },

  mounted() {
  
    this.updateScrollWidth();
  },

  methods: {
    updateScrollWidth() {
      this.$nextTick(() => {
        setTimeout(() => {
          const table = this.$refs.tableScrollContainer;
          if (table) {
            const tableEl = table.querySelector("table");
            if (tableEl) {
              this.tableScrollWidth = tableEl.scrollWidth;
            }
          }
        }, 150);
      });
    },
resetFileInput() {
  this.$refs.fileInput.value = null;
  this.file = null;
    this.uploadAttempted = false;
  this.errorMessage = "";
},


handleFileUpload(event) {
  const selectedFile = event.target.files[0];
   this.errorMessage = "";
   this.uploadAttempted = false;
  if (!selectedFile) {
    this.file = null;
    this.errorMessage = "Please select a valid CSV file.";
    return;
  }

  this.file = selectedFile;
  /* this.errorMessage = ""; */
},



    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
      this.jumpPage = null;
    },

    async uploadCsv() {
      this.errorMessage = "";
      if (!this.file) {
        this.errorMessage = "Please select a valid CSV file.";
        return;
      }
      this.isLoading = true;
      try {
        const formData = new FormData();
        formData.append("file", this.file, this.file.name);

        const response = await UploadCSVfile(formData);
        if (response.status === 200 && response.data.download_url) {
          const correctedPath = response.data.download_url.replace("/media/", "media/");
          this.downloadUrl = `${process.env.VUE_APP_API_PRODUCTION}/tax_cal/download-file/?file_path=${correctedPath}`;
         /*  this.downloadUrl = `${process.env.VUE_APP_API_PRODUCTION.replace(/\/$/, '')}/tax_cal/download-file/?file_path=${correctedPath}`;  */
          
          this.isParsing = true;
          this
          await this.fetchAndParseProcessedCSV(this.downloadUrl);

          this.file = null;
          this.$refs.fileInput.value = "";
        } else {
          this.errorMessage = "Error uploading file. Please try again.";
        }
      } catch (error) {
        console.error("Upload Error:", error);
        this.errorMessage =
          error.response?.data?.error || error.error || "Upload failed.";
        this.downloadUrl = "";
        this.csvHeaders = [];
        this.csvData = [];
        setTimeout(() => {
           this.errorMessage = ""
        },3000)
      } finally {
         this.isLoading = false;
        this.uploadAttempted = true;
         this.$refs.fileInput.value = "";
      }
    },
    async fetchAndParseProcessedCSV(url) {
         this.isLoading = true;
      try {
        const res = await fetch(url);
        const text = await res.text();

        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => {
            this.csvData = result.data;
            this.csvHeaders = result.meta.fields;
            this.tableScrollWidth = this.csvHeaders.length * 150;
            this.isParsing = false;
            this.openModal();
          },
          error: (err) => {
            console.error("Parsing failed:", err);
            this.errorMessage = "Failed to parse processed CSV.";
            this.isParsing = false;
          },
        });
      } catch (err) {
        console.error("Fetching CSV failed:", err);
        this.errorMessage = "Failed to download processed CSV.";
        this.isParsing = false;
      }
    },
    openModal() {
      if (!this.modalInstance) {
        this.modalInstance = new bootstrap.Modal(this.$refs.csvModal, {
          backdrop: "static",
          keyboard: false,
        });
      }
      this.modalInstance.show();
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
    syncScroll(source) {
      const top = this.$refs.topScroller;
      const bottom = this.$refs.tableScrollContainer;

      if (source === "top") {
        bottom.scrollLeft = top.scrollLeft;
      } else {
        top.scrollLeft = bottom.scrollLeft;
      }
    },
    async downloadCsv() {
  this.isLoading = true;
  try {
    const response = await fetch(this.downloadUrl);
    if (!response.ok) throw new Error("Failed to download file");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "processed_result.csv"; // default file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Download failed:", err);
    this.errorMessage = "Download failed. Please try again.";
    setTimeout(() => (this.errorMessage = ""), 3000);
  } finally {
    this.isLoading = false;
  }
}

  },
};
</script>

<style scoped>
.bg-custom {
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
}

.custom-card {
  background: transparent;
  color: white;
  border-radius: 15px;
  border: none;
}

.form-control,
.btn {
  border-radius: 10px;
  padding: 10px;
}

.btn-primary {
  background-color: #007bff;
  border: none;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-success {
  background-color: #28a745;
  border: none;
}

.btn-success:hover {
  background-color: #1e7e34;
}

.error-message {
  font-size: 16px;
  color: #721c24;
  background-color: #f8d7da;
  padding: 10px 15px;
  border-radius: 6px;
  border-left: 5px solid #dc3545;
}

.search-wrapper {
  max-width: 100%;
  margin: 0 auto;
}

.table-container {
  overflow-x: auto;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.custom-table th,
.custom-table td {
  padding: 12px;
  white-space: nowrap;
  vertical-align: middle;
}

.custom-table tbody tr:hover {
  background-color: #eaf4ff;
  transition: background-color 0.3s ease;
}

@media (max-width: 768px) {
  .custom-table th,
  .custom-table td {
    font-size: 13px;
    padding: 8px;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid black;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}

@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.pagination {
  flex-wrap: wrap;
}

.pagination .page-item {
  margin: 0 1px;
}

.pagination .page-link {
  border-radius: 8px;
  font-weight: bold;
}

.scroll-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}

.scroll-top {
  height: 16px;
  margin-bottom: 6px;
}

.scroll-inner {
  height: 1px;
  background: transparent;
}
</style>
